module.exports = __webpack_public_path__ + "img/flex5_5-menu-desktop.61953e18.png";